module.exports = __webpack_public_path__ + "img/qr_blue.b632e0f3.svg";